import { ITransformParams } from "../types/transform_params.js";
import { TransformBase, TransformType } from "./transform_base.js";

// Generic numeric tween: interpolates from_value -> to_value over the
// transform's duration and hands the current value to a plain callback each
// frame. For driving properties that don't have their own dedicated
// Transform* class (e.g. a nine-slice element's height/position together).
export class TransformValue extends TransformBase
{
  private readonly from_value: number;
  private readonly to_value: number;
  private readonly onUpdate: ( value: number ) => void;

  constructor(
    from_value: number,
    to_value: number,
    start_time: number,
    duration_ms: number,
    onUpdate: ( value: number ) => void,
    transform_params: ITransformParams = {}
  )
  {
    super( TransformType.Counter, start_time, duration_ms, true, transform_params );

    this.from_value = from_value;
    this.to_value = to_value;
    this.onUpdate = onUpdate;
  }

  protected getTarget(): any { return null; }

  protected initImportant(): void
  {
    this.onUpdate( this.from_value );
  }

  protected onUpdateTransform( progress: number ): void
  {
    this.onUpdate( this.from_value + ( this.to_value - this.from_value ) * progress );
  }

  public toStrTransform(): string
  {
    return `TransformValue(${this.from_value} -> ${this.to_value}, duration: ${this.getDuration()}ms)`;
  }
}
